import React from 'react';
import ContainerTemplate from '../../../../widgets/template/Container';
import PanelEstudiantesView from './PanelEstudiantesView';
import * as ROUTES from '../../../../router/Routes';

const PanelEstudiantesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.panelEstudiantes}
      routes={[ROUTES.controlEstudios, ROUTES.estudiantes]}
    >
      <PanelEstudiantesView />
    </ContainerTemplate>
  );
};

export default PanelEstudiantesModule;
